var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"borderComp"},[_c('div',{style:({
        'border-image-source': ("url('" + (_vm.configImgUrl()) + (_vm.config.borImg) + "')"),
        'border-width': ((_vm.config.width) + "px"),
        'border-image-slice': '100',
        'border-style': 'solid'
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }